/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Drawer_Inherit_DeniedInputs */



/**
* | output |
* | --- |
* | "Falls back to the organization default: denied." |
*
* @param {Rights_Drawer_Inherit_DeniedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_drawer_inherit_denied = /** @type {((inputs?: Rights_Drawer_Inherit_DeniedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Drawer_Inherit_DeniedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fällt auf den Org-Standard zurück: verweigert.")
	return /** @type {LocalizedString} */ ("Falls back to the organization default: denied.")
});